<template>
    <div>
        <div class="col-sm-12">
            <p class="text-center paragraph" style="padding: 0px 30px">
                Before you proceed, please verify you're not a robot
            </p>
            <vue-recaptcha
                v-if="site_key" 
                ref="recaptcha"
                :load-recaptcha-script="true"
                :sitekey="site_key"
                @verify="onVerify"
            >
            </vue-recaptcha>
        </div>
    </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'

import { getRecaptaToken } from '@/services/secretsService'

export default {
    components: {
        VueRecaptcha,
    },
    data() {
        return {
            robot: false,
            site_key: ''
        }
    },
    async created() {
        try {
            let data = await getRecaptaToken() // API call
            data = JSON.parse(data)
            this.site_key = data.recaptchaSecret // assign dynamically
        } catch (error) {
            console.error('❌ Failed to load recaptcha key:', error)
        }
    },
    methods: {
        submit: function () {
            if (this.robot) {
                // console.log('Robot-submit')
            }
        },
        onVerify: function (response) {
            if (response) {
                this.robot = true
                // console.log('Robot-onVerify' + JSON.stringify(response))
                this.$emit('onVerify', response)
            }
        },
    },
}
</script>
